import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {
    getAllTrafficTypeAPI
} from "../../api/trafficType";

export const fetchAllTrafficTypes = createAsyncThunk('fetchAllTrafficTypes', async (data) => {
    return await getAllTrafficTypeAPI(data)
})

const initialState = {
    allTrafficTypes: [],
    loadingTrafficTypes: false,
}

const trafficTypeSlice = createSlice({
    name: 'trafficType',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchAllTrafficTypes.pending, (state) => {
                state.loadingTrafficTypes = true;
            })
            .addCase(fetchAllTrafficTypes.fulfilled, (state, {payload}) => {
                state.allTrafficTypes = payload?.data || [];
                state.loadingTrafficTypes = false;
            })
            .addCase(fetchAllTrafficTypes.rejected, (state) => {
                state.loadingTrafficTypes = false;
            });
    },
});

export default trafficTypeSlice.reducer;
